import React from "react";

interface AdminProps {
  admin: {
    id: string;
    firstName: string;
    lastName: string;
    jobTitle: string;
    phone: string;
    createdAt: string;
    updatedAt: string;
    userId: string;
    user: {
      email: string;
      createdAt: string;
    };
  };
}

const AdminCard: React.FC<AdminProps> = ({ admin }) => {
  return (
    <div className="admin-card">
      <h2>
        {admin.firstName} {admin.lastName}
      </h2>
      <p className="admin-title">{admin.jobTitle}</p>
      <p>📧 {admin.user.email}</p>
      <p>📞 {admin.phone}</p>
      <p className="admin-meta">User ID: {admin.userId}</p>
      <p className="admin-meta">
        Created: {new Date(admin.createdAt).toLocaleDateString()}
      </p>
      <p className="admin-meta">
        Updated: {new Date(admin.updatedAt).toLocaleDateString()}
      </p>
    </div>
  );
};

export default AdminCard;
